import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from "@angular/core";
import * as _ from "lodash";
import {PlanningViewSettingsJobsModel} from "../../../models/planning-view-settings.model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";

require('./planning-draft-jobs-panel-list.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-jobs-panel-list',
  templateUrl: './planning-draft-jobs-panel-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobsPanelListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() draft?: boolean;
  @Input() jobs: any;
  @Input() routes: any[];
  @Input() selectedIds: string[];
  @Input() highlightedActivity: any;
  @Input() settings: PlanningViewSettingsJobsModel;
  @Input() isHideSelect: boolean;
  @Output() onSelect = new EventEmitter<string[]>();
  @Output() onViewJob = new EventEmitter<{ jobs?: any[], jobIds?: string[], event?: any }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();

  public selectedKeys: Object;
  public routesByJobMap: Object;


  private scrollEndTimer: any | null = null;
  private scrollRafId: number | null = null;
  @ViewChild(CdkVirtualScrollViewport, {static: false}) viewport: CdkVirtualScrollViewport;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.scrollRafId !== null) {
      cancelAnimationFrame(this.scrollRafId);
      this.scrollRafId = null;
    }
    if (this.scrollEndTimer) {
      clearTimeout(this.scrollEndTimer);
      this.scrollEndTimer = null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      });
    }
    if (changes.routes) {
      this.routesByJobMap = {};
      if (this.routes?.length) {
        this.routes.forEach((r) => {
          r.jobIds.forEach((id) => {
            this.routesByJobMap[id] = r;
          })
        })
      }
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.viewport?.checkViewportSize();
  }

  onScroll(_: Event): void {
    // Workaround for CDK autosize bug: content wrapper sometimes goes blank or
    // out of place during/after scroll. Self-heal during scroll (rAF throttled,
    // cheap reads) plus a final check after scroll stops.
    if (this.scrollRafId === null) {
      this.scrollRafId = requestAnimationFrame(() => {
        this.scrollRafId = null;
        this._fixViewportIfBroken();
      });
    }
    if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
    this.scrollEndTimer = setTimeout(() => {
      this.scrollEndTimer = null;
      this._fixViewportIfBroken();
    }, 150);
  }

  private _fixViewportIfBroken(): void {
    if (!this.viewport || !(this.jobs?.length > 0)) return;
    const viewportEl = this.viewport.elementRef.nativeElement;
    const wrapper = viewportEl.querySelector('.cdk-virtual-scroll-content-wrapper');
    if (!wrapper) return;
    const vr = viewportEl.getBoundingClientRect();
    if (vr.height === 0) return; // viewport not visible (hidden tab/panel)
    const wr = wrapper.getBoundingClientRect();
    const isBlank = wr.height === 0;
    const isOutOfPlace = (wr.bottom < vr.top) || (wr.top > vr.bottom);
    if (isBlank || isOutOfPlace) {
      this.viewport.checkViewportSize();
    }
  }

  onToggleSelectedJob(id, isSelected: boolean) {
    this.selectedKeys[id] = isSelected;
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });

    this.onSelect.emit(_.compact(selectedIds));
  }

  trackById(_: number, item: { id: string | number }): string | number {
    return item.id;
  }
}
